import { number, object, string } from 'yup';

export const transactionInformationValidationSchema = object().shape({
    status: string().required('Status is required'),
    holding_type: string().required('Holding Type is required'),
    shares: string().notRequired(),
    ownership_stake: number().nullable(true).min(0.01, 'Ownership Stake minimum is 0.01').max(100, 'Ownership Stake maximum is 100'),
});
